<script setup>
import { computed } from 'vue';
import AppIcon from '../atoms/app/AppIcon.vue';
import { useJobDataStore } from '../../stores/job-store';

defineProps({
    minimalPadding: {
        type: Boolean,
    },
    noBorder: {
        type: Boolean,
    },
});

const job = useJobDataStore();
const companyLogo = computed(() => job.company?.logo?.companysquare ?? null);
</script>

<template>
    <div
        class="k-c-imageBox flex justify-center items-center text-gray-300 bg-white rounded-md overflow-hidden"
        :class="{
            'pt-s': !companyLogo,
            'p-[2px]': minimalPadding,
            'border-0': noBorder,
            '!p-0': companyLogo,
        }"
    >
        <img
            v-if="companyLogo"
            :src="companyLogo"
            :alt="`Logo des Arbeitgebers ${job.company?.name}`"
        >
        <AppIcon
            v-else
            name="employer-branding"
            size="3xl"
        />
    </div>
</template>

<style lang="scss">
@import '~@karriereat/global-styles/scss/components/image-box';

</style>
